import React from 'react';
import { useTranslation } from 'react-i18next';
import PhotoCameraIcon from '@mui/icons-material/PhotoCameraOutlined';

import Button from '@ui-lib/components/Button';
import { createSx } from '@ui-lib/utils';
import { useBolAuthToken } from '../../../../../../BolDetails/components/DeliveryTokenContext';
import AddPhotoModal from '../../../../../../../../../components/AddPhoto/components/AddPhotoModal';

import { useAddPhoto } from '../../../../../../../../../components/AddPhoto/hooks/useAddPhoto';
import { CameraError } from '../../../../../../../../../components/AddPhoto/components/CameraError';
import { PHOTO_TYPE } from '../../../../../../../../../api/types/PhotoType';

const sx = createSx({
  button: {
    width: 'fit-content',
  }
});

interface Props {
  setPhoto: (photo: string) => void;
}

const AddPhotoButton = (({ setPhoto }: Props) => {
  const { t } = useTranslation();
  const token = useBolAuthToken();

  const {
    open,
    handleModalStateChange,
    cameraError,
    setCameraError,
    loading,
    savePhoto,
    openCamera,
  } = useAddPhoto(setPhoto, PHOTO_TYPE.ACTUAL);

  if (!token) return null;

  return (
    <>
      {cameraError ? (
        <CameraError
          errorMessage={cameraError}
          onRetry={handleModalStateChange}
        />
      ) : (
        <Button
          variant='text'
          loading={loading}
          onClick={openCamera}
          startIcon={<PhotoCameraIcon />}
          sx={sx.button}
        >
          {t('label_addPhotos')}
        </Button>
      )}
      <AddPhotoModal
        open={open}
        onClose={handleModalStateChange}
        onCapture={(imageSrc) => savePhoto(token, imageSrc)}
        cameraError={cameraError}
        setCameraError={setCameraError}
      />
    </>
  );
});

export default AddPhotoButton;